import { useEffect, useState } from 'react';

export const useTextAnimation = ({
  text,
  enabled = true,
  duration = 10,
  letterPerDuration = 10,
}: {
  text: string;
  enabled?: boolean;
  complete?: boolean;
  duration?: number;
  letterPerDuration?: number;
}) => {
  const [displayTextLength, setDisplayTextLength] = useState(0);
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    let lastTime = performance.now();
    let animationFrameId: number;

    const animate = (currentTime: number) => {
      const deltaTime = currentTime - lastTime;

      if (deltaTime >= duration) {
        if (displayTextLength < text.length + 10) {
          setDisplayTextLength(displayTextLength + letterPerDuration);
        } else {
          setComplete(true);
        }
        lastTime = currentTime;
      }

      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [displayTextLength, text, enabled, duration, letterPerDuration]);

  return {
    displayTextLength,
    complete,
    text: text.split('').slice(0, displayTextLength).join(''),
  };
};
